import { Trans, useTranslation } from 'react-i18next'
import { cn } from 'src/utils/cx'
import { FEATURE_ICONS } from '../constants'
import css from '../Landing.module.css'
import { useFadeUp } from './useFadeUp'

export default function FeaturesSection() {
  const { t } = useTranslation('blackboard', { keyPrefix: 'welcome' })
  const fadeRef = useFadeUp()

  return (
    <section id="features" className="py-24">
      <div className="mx-auto max-w-[1200px] px-6">
        <div ref={fadeRef} className={cn(css.fadeUp)}>
          <div className="mb-2 text-sm font-bold uppercase tracking-wider text-[--landing-pink]">
            {t('features.section-label')}
          </div>
          <h2 className="mb-4 text-4xl font-semibold leading-tight text-gray-900">
            <Trans
              i18nKey="blackboard:welcome.features.heading"
              components={{
                highlight: <span className={css.gradientText} />,
              }}
            />
          </h2>
          <p className="max-w-[600px] text-base text-gray-500">
            {t('features.subheading')}
          </p>
        </div>

        <div className="mt-12 grid gap-5 md:grid-cols-2">
          {FEATURE_ICONS.map((Icon, i) => (
            <div
              key={i}
              className="rounded-3xl border-[1.5px] border-gray-200 bg-white p-8"
            >
              <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-[14px] bg-[--landing-pink-bg]">
                <Icon className="size-6 text-[--landing-pink]" />
              </div>
              <h3 className="mb-2 text-lg font-bold">
                {t(`features.items.${i}.title`)}
              </h3>
              <p className="text-sm text-gray-500">
                {t(`features.items.${i}.desc`)}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
